<div id="icd-9" class="main__search mb-2 relative">
    <div  #boxSearch class=" bar-1 bg-white flex items-center relative">
     
            <div class="w-[50px] h-full flex items-center justify-center">
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    class="translate-x-[2px]"
                    height="24"
                    fill="#5F6368"
                >
                    <path
                        d="M15.5 14h-.79l-.28-.27A6.471 6.471 0 0 0 16 9.5 6.5 6.5 0 1 0 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"
                    />
                </svg>
            </div>
            <input
                autocomplete="off"
                #searchInput
                [(ngModel)]="debouncedValue"
                (input)="handleInputChange()"
                (keydown)="handleKeyDown($event)"
                (focus)="handleOpen()"
                id="search"
                class="searchbar"
                autocomplete="off"
                placeholder="{{
                    language === 'en' ? 'Enter keywords to search' : 'Nhập từ khóa để tìm kiếm...'
                }}"
                type="text"
                title="Search"
            />
            <div
                (click)="handleDelInput()"
                [ngClass]="{ hidden: debouncedValue.length <= 0, flex: debouncedValue.length > 0 }"
                class="w-[50px] h-full items-center justify-center cursor-pointer z-[1001]"
            >
                <svg
                    focusable="false"
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    *ngIf="!isSearching"
                >
                    <path
                        fill="#70757a"
                        d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
                    ></path>
                </svg>
                <div class="spinner-container">
                    <div class="spinner" *ngIf="isSearching"></div>
                </div>
            </div>
            
    </div>
   
    <div  #recommendBox  id="recommend-box" class="search-result" *ngIf="searchResults && isShowResult" #menu>
        <div [innerHTML]="searchResults?.html" (click)="searchItem($event)"></div>
    </div>
</div>
